"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SheetFooter = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const button_utils_1 = require("@/components/common/button/button.utils");
const overlay_styles_1 = require("@/components/overlay/overlay.styles");
require("@/components/common");
let SheetFooter = class SheetFooter extends lit_1.LitElement {
    render() {
        return (0, button_utils_1.renderActionButtons)({
            primaryAction: this.primaryAction,
            secondaryAction: this.secondaryAction,
            size: 'large',
        });
    }
};
SheetFooter.styles = overlay_styles_1.sheetFooterStyles;
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], SheetFooter.prototype, "primaryAction", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], SheetFooter.prototype, "secondaryAction", void 0);
SheetFooter = __decorate([
    (0, decorators_js_1.customElement)('mm-sheet-footer')
], SheetFooter);
exports.SheetFooter = SheetFooter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hlZXQtZm9vdGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2hlZXQtZm9vdGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFnQztBQUNoQyxxREFBMkQ7QUFJM0QsMEVBQTZFO0FBQzdFLHdFQUF1RTtBQUN2RSwrQkFBNEI7QUFHckIsSUFBTSxXQUFXLEdBQWpCLE1BQU0sV0FBWSxTQUFRLGdCQUFVO0lBS3pDLE1BQU07UUFDSixPQUFPLElBQUEsa0NBQW1CLEVBQUM7WUFDekIsYUFBYSxFQUFFLElBQUksQ0FBQyxhQUFhO1lBQ2pDLGVBQWUsRUFBRSxJQUFJLENBQUMsZUFBZTtZQUNyQyxJQUFJLEVBQUUsT0FBTztTQUNkLENBQUMsQ0FBQTtJQUNKLENBQUM7O0FBVk0sa0JBQU0sR0FBRyxrQ0FBaUIsQ0FBQTtBQUNEO0lBQS9CLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQztrREFBNkI7QUFDNUI7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDO29EQUErQjtBQUhuRCxXQUFXO0lBRHZCLElBQUEsNkJBQWEsRUFBQyxpQkFBaUIsQ0FBQztHQUNwQixXQUFXLENBWXZCO0FBWlksa0NBQVcifQ==